import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'negocio-item-modal',
  templateUrl: './negocio-item-modal.component.html',
  styleUrls: ['./negocio-item-modal.component.scss']
})
export class NegocioItemModalComponent implements OnInit {

  public data:any = null;

  constructor(
    public dialog: MatDialogRef<NegocioItemModalComponent>,
    @Inject(MAT_DIALOG_DATA) public _data,
    private app: AppService
  ){

    this.data = this._data.item;

  }
  /**
   * 
   * Open Whats
   * 
   */
  openWhats(){

    let telefone = this.data.empresa_telefone.replace("(","").replace(")","").replace("-","").replace(" ","");

    let numero  = "55"+telefone;
    let prefixo = this.app.isMobile() ? "api" : "web";

    window.open("https://"+prefixo+".whatsapp.com/send?phone="+numero,"__blank");

    return false;

  }
  /**
   * 
   * Init
   * 
   */
  ngOnInit():void{}

}
